// Package placeholder
export const LIB = 1;
